import React from 'react';
import { Progress } from '../ui/progress';
import { Loader2, FileSearch, ScanLine, CheckCircle2 } from 'lucide-react';

export default function ExtractionProgressPanel({ progress, fileCount, currentFile }) {
  const stages = [
    { label: 'Uploading files', threshold: 25, icon: Loader2 },
    { label: 'Running OCR', threshold: 60, icon: ScanLine },
    { label: 'Extracting fields', threshold: 90, icon: FileSearch },
    { label: 'Complete', threshold: 100, icon: CheckCircle2 },
  ];

  const currentStage = stages.find(s => progress <= s.threshold) || stages[stages.length - 1];
  const StageIcon = currentStage.icon;

  return (
    <div className="py-8 space-y-6" data-testid="extraction-progress-panel">
      <div className="flex flex-col items-center gap-3">
        <div className="p-4 bg-blue-50 rounded-full animate-pulse">
          <StageIcon className="h-8 w-8 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{currentStage.label}</h3>
        <p className="text-sm text-gray-500">
          Processing file {Math.min(currentFile, fileCount)} of {fileCount}
        </p>
      </div>

      <div className="max-w-md mx-auto space-y-2">
        <Progress value={progress} className="h-2" />
        <p className="text-xs text-center text-gray-400">{progress}%</p>
      </div>

      <div className="flex justify-center gap-6 text-xs text-gray-500">
        {stages.slice(0, 3).map((s, i) => {
          const done = progress > s.threshold;
          const active = currentStage.label === s.label;
          return (
            <div key={i} className={`flex items-center gap-1 ${active ? 'text-blue-600 font-medium' : ''} ${done ? 'text-green-600' : ''}`}>
              {done ? <CheckCircle2 className="h-3 w-3" /> : <span className="h-3 w-3 rounded-full border border-current inline-block" />}
              {s.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
